import styled from '@emotion/styled';
import React, { useEffect, useRef, useState } from 'react';
import { Slide, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import { getAppOsInfo } from '../../utils';
import { FooterContainer } from './FooterContainer';
import { HeaderContainer } from './HeaderContainer';

interface PageLayoutProps {
  children: JSX.Element;
}

export const PageLayout = ({
  children,
}: PageLayoutProps): React.ReactElement => {
  const [footerHeight, setFooterHeight] = useState<number>(0);
  const footerRef = useRef<HTMLDivElement>(null);
  const isAndroid = getAppOsInfo()?.osType === 'Android';

  useEffect(() => {
    const handleFooterHeight = (): void => {
      if (!footerRef.current) {
        return;
      }

      setFooterHeight(footerRef.current.offsetHeight);
    };

    if (footerRef.current) {
      setFooterHeight(footerRef.current.offsetHeight);
      window.addEventListener('resize', handleFooterHeight);
    }

    return () => {
      window.removeEventListener('resize', handleFooterHeight);
    };
  }, [footerRef]);

  return (
    <ContainerColumn>
      <HeaderContainer />
      <ContainerRow footerHeight={footerHeight}>
        <ContentsContainer>
          <PageWrap>{children}</PageWrap>
        </ContentsContainer>
      </ContainerRow>
      <FooterContainer footerRef={footerRef} />
      <ToastContainer
        position="bottom-center"
        hideProgressBar
        autoClose={2000}
        transition={Slide}
        style={{
          marginBottom: isAndroid ? '42px' : '0px',
          zIndex: 10001,
        }}
      />
    </ContainerColumn>
  );
};

const ContainerColumn = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  position: relative;
`;

const ContainerRow = styled.div<{ footerHeight: number }>`
  display: flex;
  width: 100%;
  padding-bottom: ${({ footerHeight }) => footerHeight}px;
`;

const ContentsContainer = styled.div`
  width: 100%;
  @media screen and (min-width: 768px) {
    padding: 0px 60px;
    margin: 0 auto;
    box-sizing: border-box;
    flex: 1 0 auto;
    max-width: 1256px;
  }
`;

const PageWrap = styled.div`
  width: 100%;
`;
